import { render, staticRenderFns } from "./receiptFinder.vue?vue&type=template&id=37b97ff0"
import script from "./receiptFinder.vue?vue&type=script&lang=js"
export * from "./receiptFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports